module.exports = __webpack_public_path__ + "static/media/pikto_rebusy.57651b13.png";